// mentioned by priority
export default {
    globalAdmin: 'globalAdmin',
    localAdmin: 'localAdmin',
    fleetAdmin: 'fleetAdmin',
    fleetManager: 'fleetManager',
    user: 'user'
}